import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

const getTooltipOverlay = (tooltipID, content) => (
  <Tooltip id={tooltipID}>
    {content}
  </Tooltip>
);

const InfoTooltip = ({ tooltipID, content, disabled }) => {
  if (!content || disabled) {
    return null;
  }

  const tooltiper = getTooltipOverlay(tooltipID, content);

  return (
    <OverlayTrigger placement="top" overlay={tooltiper}>
      <div className="glyphicon glyphicon-info-sign" />
    </OverlayTrigger>
  );
};

InfoTooltip.propTypes = {
  /** tooltip ID */
  tooltipID: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /** tooltip content */
  content: PropTypes.any,
  /** controls if tooltip is shown or not */
  disabled: PropTypes.bool,
};

InfoTooltip.defaultProps = {
  tooltipID: '',
  content: null,
  disabled: false,
};

export default InfoTooltip;
